module.exports = __webpack_public_path__ + "img/mountains-icon.413208ed.svg";